import { render } from "./TableHistoricMethods.vue?vue&type=template&id=40f73676&scoped=true"
import script from "./TableHistoricMethods.vue?vue&type=script&lang=js"
export * from "./TableHistoricMethods.vue?vue&type=script&lang=js"

import "./TableHistoricMethods.vue?vue&type=style&index=0&id=40f73676&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f73676"]])

export default __exports__